import React, { useCallback, useState } from 'react'
import classNames from 'classnames'

import { DepthKeys, useLanguages } from '@/hooks'

export const services: {
  icon: string
  desc: DepthKeys
  label: DepthKeys
  isDisabled?: boolean
}[] = [
  {
    desc: 'checkInDesc',
    icon: 'icon--check-in',
    label: 'acceleratedCheckIn',
  },
  {
    desc: 'afterHoursDesc',
    icon: 'icon--after-hours',
    label: 'afterHoursServices',
  },
  {
    isDisabled: true,
    desc: 'selfService',
    icon: 'icon--kiosk',
    label: 'selfServiceKiosk',
  },
  {
    isDisabled: true,
    desc: 'counterDesc',
    icon: 'icon--counter',
    label: 'skipTheCounter',
  },
]

export const Services: React.FC = () => {
  const { rich, t } = useLanguages()
  const [activeItem, setActive] = useState<number>()

  const onSetActive = useCallback(
    (value: number) => () => {
      setActive(prev => (prev === value ? undefined : value))
    },
    [],
  )

  return (
    <div className="row">
      <div className="column small-12">
        <h2 className="white-color">{t('locationServices')}</h2>
      </div>
      {services.map((service, idx) => (
        <div key={idx} className="column small-12 medium-6 large-3">
          <div
            className={classNames('location_item_wrapper', {
              disabled: service.isDisabled,
            })}
          >
            <div
              className={classNames('location_item', service.icon)}
              onClick={service.isDisabled ? () => null : onSetActive(idx)}
            >
              <h4>{t(service.label)}</h4>
              <span className="icon--toggler"></span>
            </div>
            <div
              className={classNames('location_info', {
                active: idx === activeItem,
              })}
            >
              {rich(service.desc, {
                p: text => <p>{text}</p>,
                h3: text => <h3>{text}</h3>,
              })}
            </div>
          </div>
          {service.isDisabled && (
            <span className="description white-color">
              {t('unavailableAtThisLocation')}
            </span>
          )}
        </div>
      ))}
    </div>
  )
}
